import { HTMLAttributes } from 'react';

import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';

interface Props extends HTMLAttributes<HTMLParagraphElement> {
  config?: { [key in string]: string };
  defaultValue?: string | number;
  withTooltip?: boolean;
}

export const renderEllipsisText =
  ({ config, defaultValue, withTooltip = false, ...props }: Props = {}) =>
  ({ getValue }) => {
    const text = config ? config[getValue() || defaultValue] : getValue()?.trim() || defaultValue;

    return (
      <Tooltip>
        <TooltipTrigger>
          <p
            style={{
              width: '100%',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
            {...props}
          >
            {text}
          </p>
        </TooltipTrigger>
        {withTooltip && <TooltipContent> {text}</TooltipContent>}
      </Tooltip>
    );
  };
